import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/*
 * Tailwind class composer. Combines `clsx` (conditional/array/object class
 * inputs, falsy values dropped) with `tailwind-merge` (deduplicates
 * conflicting Tailwind utilities so the last value wins regardless of
 * source order). Use anywhere a shared primitive accepts a `className`
 * override that may conflict with its base classes.
 */
export function twcn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
